module.exports = __webpack_public_path__ + "static/media/6.744cddf8.jpg";